import React from "react";

// Style \\
import "../../assets/styles/sections/aboutUsSection.scss";

import AboutUsCard from "../cards/AboutUsCard";

// Images \\
// import aboutImg from "../../assets/images/action.jpg";

const AboutUsSection = () => {
  return (
    <section className="aboutSection">
      <div className="containers">
        <div className="aboutSection_item">
          <div className="about_item_title text-center">
            <h3>About Us</h3>
            <p className="text-xl w-2/4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
              commodo, arcu quis luctus fringilla, nisi est tincidunt lectus,
              sed luctus enim lectus vel libero
            </p>
          </div>

          <div className="content_box">
            <AboutUsCard />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
